export const CHECKOUT_URL = 'https://como-perder-grasa-en-45-dias.impultienda.ar/checkout'

const TRACKING_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'fbclid',
  'gclid',
  'ttclid',
]

const STORAGE_KEY = 'tracking-params-45dias'

/** Lee los parámetros UTM de la URL actual y los guarda para no perderlos al navegar. */
export function captureTrackingParams(): Record<string, string> {
  const fromUrl: Record<string, string> = {}
  try {
    const search = new URLSearchParams(window.location.search)
    TRACKING_KEYS.forEach((key) => {
      const value = search.get(key)
      if (value) fromUrl[key] = value
    })

    if (Object.keys(fromUrl).length > 0) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl))
      return fromUrl
    }

    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored ? (JSON.parse(stored) as Record<string, string>) : {}
  } catch {
    return fromUrl
  }
}

/** Arma el link al checkout con los parámetros UTM del visitante. */
export function buildCheckoutUrl(): string {
  const url = new URL(CHECKOUT_URL)
  const params = captureTrackingParams()
  Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value))
  return url.toString()
}
